module.exports = __webpack_public_path__ + "static/media/science0.45a664cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/science0.jpg
// module id = 581
// module chunks = 0